
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/my-services",
      function () {
        return require("private-next-pages/my-account/my-services.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/my-services"])
      });
    }
  